import { SiteDetail, SiteParams, SiteResponse, Sites } from '@/types/site.types';
import api from './api';

export const handleCreateSite = async (params: SiteParams) => api.post<SiteResponse>('/Sites/NewSite', { ...params });

export const handleGetSites = async ({page, perPage}:Sites.Request) => api.get<Sites.Response>(`/Sites/ListSites?page=${page}&perPage=${perPage}`, {});

export const handleGetSitesDetails = async ({id, page, perPage}:SiteDetail.Request) => api.get<SiteDetail.Response>(`/Sites/Detail/${id}?page=${page}&perPage=${perPage}`, {});
